import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import DatePicker from "react-datepicker";
import { adminActions } from "../../redux/actions";
import "react-datepicker/dist/react-datepicker.css";

export const FilterRidersRemitted = ({
  date,
  remitted_start_date,
  setStartDate = () => {},
  remitted_end_date,
  setEndDate = () => {},
}) => {
  let params = useParams();

  const dispatch = useDispatch();

  // Initial filter on component mount if both dates are provided
  useEffect(() => {
    if (remitted_start_date && remitted_end_date) {
      const payload = {
        start_date: remitted_start_date,
        end_date: remitted_end_date,
      };
      dispatch(adminActions.filterCourierRemittedOrders(payload, params.page));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleStartDateChange = (date) => {
    setStartDate(date);

    if (date && remitted_end_date) {
      const payload = {
        start_date: date,
        end_date: remitted_end_date,
      };
      dispatch(adminActions.filterCourierRemittedOrders(payload, params.page));
    }
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);

    if (remitted_start_date && date) {
      const payload = {
        start_date: remitted_start_date,
        end_date: date,
      };
      dispatch(adminActions.filterCourierRemittedOrders(payload, params.page));
    }
  };

  return (
    <div>
      <div className="separator-breadcrumb border-top" />
      <div className="date-picker-wrapper">
        <form>
          <div className="row" style={{ marginLeft: "10px" }}>
            <i
              className=" 
            i-Calendar-4"
              style={{ marginRight: "10px", marginTop: "10px" }}
            />
            <div className="allign col-md-6">
              <div
                className={
                  "div-box" + (!remitted_start_date ? " is-invalid" : "")
                }
              >
                <DatePicker
                  className="form-control"
                  name="remitted_start_date"
                  selected={remitted_start_date}
                  onChange={handleStartDateChange}
                />
              </div>
              <span style={{ margin: "2px 2px" }}>-</span>
              <div
                className={
                  "div-box " + (!remitted_end_date ? " is-invalid" : "")
                }
              >
                <DatePicker
                  className="form-control"
                  selected={remitted_end_date}
                  onChange={handleEndDateChange}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
